import { Env } from '@stencil/core';

export function getApiBaseURL() {
  const baseUrl = Env.API_BASE_URL ?? 'http://localhost/';

  return baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
}

function getApiTablaDefUrl() {
  return `${getApiBaseURL()}/RecuperarDatosTablas`;
}

export function getTablaDefGetUrl() {
  return `${getApiTablaDefUrl()}/RecuperarDatosTablas`;
}
export function getTablaDefSaveUrl() {
  return `${getApiTablaDefUrl()}/GrabarDatosTablas`;
}
